import React from 'react';
import EventListItem from '../Event/EventListItem.react';
import EventActions from '../../actions/EventActionCreator';
import ModuleActions from '../../actions/ModuleActionCreator';

import AttendIcon from 'material-ui/svg-icons/navigation/check';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import EventIcon from 'material-ui/svg-icons/action/event';
import EventAvailableIcon from 'material-ui/svg-icons/notification/event-available';
import PersonIcon from 'material-ui/svg-icons/social/person';

import { avatar as avatarColours } from '../../constants/ColourConstants';
import PropTypes from 'prop-types';

class ModuleEventListItem extends EventListItem {

    getActions(row) {
        let actions = super.getActions(row);
        const attendeeLink = `/dashboard/event/${row.id}/attendees`;
        const index = actions.findIndex(action => action.label === 'Preview') + 1;
        actions.splice(index, 0,
            {
                link: attendeeLink,
                label: 'List attendees',
                icon: <PersonIcon/>
            }
        );
        if (this.props.data.attendanceStatus !== 'attended' && new Date(this.props.data.timeStart) > Date.now()) {
            actions.splice(index, 0,
                {
                    icon: this.props.data.attendanceStatus === null ? <AttendIcon/> : <CancelIcon/>,
                    label: this.props.data.attendanceStatus === null ? 'Attend event' : 'Cancel Attendance',
                    action: () => {this.toggleAttendance(this.props.data.id)},
                    key: 'attend'
                },
            );
        }
        return actions;
    }

    getPrimaryLink({id, moduleId}) {
        return `/dashboard/module/${moduleId}/event/${id}`;
    }

    getAvatarStyle() {
        if (this.props.data.attendanceStatus !== null) {
            return avatarColours[`${this.props.data.attendanceStatus}Event`];
        }
        return avatarColours.default;
    }

    getAvatarIcon() {
        if (this.props.data.attendanceStatus === 'attended' || this.props.data.attendanceStatus === 'attending') {
            return <EventAvailableIcon/>;
        }
        return <EventIcon/>;
    }

    _onDelete(eventId) {
        if (eventId === this.props.data.id) {
            ModuleActions.removeEvent(this.props.data);
        }
    }

    _onDeletePeriodicInstance() {
        // todo
    }

    _onDeletePeriodicAllInstances() {
        // todo
    }

    _onDeletePeriodicWithFollowingInstances() {
        // todo
    }

    toggleAttendance(eventId) {
        if (this.props.data.attendanceStatus === 'waiting' || this.props.data.attendanceStatus === 'attending') {
            EventActions.removeMyAttendance(eventId, {userId: this.context.auth.identity.id});
        } else {
            EventActions.addMyAttendance(eventId);
        }
    }
}

ModuleEventListItem.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default ModuleEventListItem;
